var NewOnEdelDTO = /** @class */ (function () {
    function NewOnEdelDTO(params) {
        this.bottomRightImage = params.url + params.bottomRightImage;
        this.centerImage = params.url + params.centerImage;
        this.description = params.description;
        this.highlightText = params.highlightText;
        this.tag = params.tag;
        this.url = params.url;
    }
    return NewOnEdelDTO;
}());
export default NewOnEdelDTO;
